import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { ContactType, ParkSessionStatus } from "ipctg-inflow-types/InFlowEnums"

import api from "@/utilities/api"

import { cleanEmptyParams, matchesToRoutes } from "@/utilities/etc"
import { log } from "@/utilities/logging"
import welcomeTokenStorage from "@/utilities/WelcomeTokenStorage"

/*
  Hopefully we can get rid of this at some point.
  Its annoying having to carry this stuff around
  from the first to the last freggin page.
*/
export interface ContactSearchParams {
  phone: string
  email: string
  contactType: ContactType
}

export function validateContactSearchParams(
  search: Record<string, unknown>
): ContactSearchParams {
  return cleanEmptyParams({
    phone: (search.phone as string) || "",
    email: (search.email as string) || "",
    contactType:
      (search.contactType as string) === ContactType.Email
        ? ContactType.Email
        : ContactType.Phone,
  })
}

export const Route = createFileRoute("/qr/$qrLookupID/park/$epoch")({
  beforeLoad: async ({ params, matches }) => {
    // Validate epoch from URL - prevent access to old sessions
    const isValidEpoch = welcomeTokenStorage.validateEpochFromUrl({
      epoch: params.epoch,
      flow: "park",
    })

    if (!isValidEpoch) {
      log({
        level: "warn",
        flow: "park",
        scope: "guard.epoch",
        message: "Invalid epoch, redirecting to /welcome",
      })

      throw redirect({ to: "/qr/$qrLookupID/welcome", params })
    }

    // Check session status
    const sessionState = await api.park.sessionStatus.POST({})

    // If payment is complete and not already on payment-complete or confirmation page, redirect
    if (
      sessionState.status === ParkSessionStatus.Complete &&
      !matchesToRoutes({
        matches,
        paths: [
          "/qr/$qrLookupID/park/$epoch/confirmation",
          "/qr/$qrLookupID/park/$epoch/payment-complete",
        ],
      })
    ) {
      log({
        level: "warn",
        flow: "park",
        scope: "guard.sessionState",
        message: "Session status is complete, redirecting to /payment-complete",
        meta: { sessionState },
      })
      throw redirect({
        to: "/qr/$qrLookupID/park/$epoch/payment-complete",
        params: {
          qrLookupID: params.qrLookupID,
          epoch: params.epoch,
        },
      })
    }

    return { sessionState }
  },
  component: Outlet,
})
